import type { ContentData } from "@/api/content";
import { useLang } from "@/i18n/LanguageContext";

/** Checklist render. Interactive (ticks persist) when `onToggle` is given and not read-only. */
export function ChecklistView({
  content,
  onToggle,
  readOnly,
}: {
  content: ContentData;
  onToggle?: (index: number, checked: boolean) => void;
  readOnly?: boolean;
}) {
  const { t } = useLang();
  const items = content.items ?? [];
  if (items.length === 0) return <p className="no-data-message">{t("Geen punten.", "No items.")}</p>;
  const interactive = !!onToggle && !readOnly;

  return (
    <div className="checklist">
      {content.intro && <p className="checklist-intro">{content.intro}</p>}
      <ul>
        {items.map((it, i) => (
          <li key={i} className={it.checked ? "is-checked" : ""}>
            <input
              type="checkbox"
              className="checklist-cb"
              checked={!!it.checked}
              disabled={!interactive}
              onChange={(e) => onToggle?.(i, e.target.checked)}
            />
            <span className="checklist-text">{it.text}</span>
            {it.required && <span className="checklist-req">{t("verplicht", "required")}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
